module.exports = __webpack_public_path__ + "static/media/background.bdf0b8bf.png";